<template>
  <BaseNode v-bind="props">
    <template #header>
      <BaseHtmlContent class="node__title" :html="processText(node.question, decisionTree.context)" />
    </template>
    <template #body>
      <BaseSelect v-model="selectedVisitTypeId" :options="options"></BaseSelect>
      <div class="visit-type-help">
        <sp-expandable-area
          size="27"
          title="Which type is right for me?"
          color="var(--sp-dtv-toggle-activator-color, #007078)"
        >
          <dl v-for="visitType in filteredVisitTypes" class="visit-type-help__link" :key="visitType.id">
            <dt class="visit-type-name">
              <i class="icon" :class="`icon-${visitType.category}-visit`"></i> {{ visitType.name }}
            </dt>
            <BaseHtmlContent tag="dd" :html="visitType.help" />
          </dl>
        </sp-expandable-area>
      </div>
    </template>
  </BaseNode>
</template>

<script setup>
import { useSnippetProcessor } from "../../composables/useSnippetProcessor";

import { computed } from "vue";

const props = defineProps({
  node: {
    type: Object,
    required: true,
  },
  decisionTree: {
    type: Object,
    required: true,
  },
});

const filteredVisitTypes = computed(() => props.node.filteredVisitTypes(props.decisionTree.context));

const options = computed(() =>
  filteredVisitTypes.value.map((visitType) => ({
    label: visitType.name,
    value: visitType.id.toString(),
  })),
);

const selectedVisitTypeId = computed({
  get() {
    return props.node.selectedVisitTypeId?.toString();
  },
  set(idString) {
    props.node.selectedVisitTypeId = idString ? Number(idString) : undefined;
  },
});

const { processText } = useSnippetProcessor();
</script>

<style scoped lang="scss">
.visit-type-help,
.visit-type-help__link {
  margin-top: 1rem;
}
.visit-type-name {
  font-weight: var(--sp-dtv-visit-type-node-name-font-weight, 700);
}
</style>
